<template>
    <div ref="dropdownRef" class="dropdown">
        <button :id="id" type="button" :class="{'dropdown-header': true, open: isOpen}" :aria-expanded="isOpen" @click="toggleDropdown">
            <slot name="header"></slot>
        </button>
        <div role="region" :class="{'dropdown-content': true, open: isOpen, [menuClass]: true}" :aria-labelledby="id">
            <slot name="content"></slot>
        </div>
    </div>
</template>

<script setup lang="ts">
    import {onBeforeUnmount, onMounted, ref, useTemplateRef} from 'vue';
    import {onClickOutside} from '@malt/utils';

    const isOpen = ref(false);
    const dropdownRef = useTemplateRef('dropdownRef');

    withDefaults(
        defineProps<{
            id: string;
            menuClass?: string;
        }>(),
        {
            menuClass: '',
        },
    );

    function toggleDropdown() {
        isOpen.value = !isOpen.value;
    }

    function closeDropdown() {
        isOpen.value = false;
    }

    onClickOutside(dropdownRef, () => {
        isOpen.value = false;
    });

    onMounted(() => {
        window.addEventListener('Navigation', closeDropdown);
    });

    onBeforeUnmount(() => {
        window.removeEventListener('Navigation', closeDropdown);
    });
</script>

<style lang="scss" scoped>
    @use '@navbar-unlogged/scss/variables.scss' as vars;

    .dropdown {
        position: relative;

        .dropdown-header {
            background-color: transparent;
            width: 100%;
            padding: 0;
            border: none;

            @include vars.flex-row-align-center;

            justify-content: space-between;
            cursor: pointer;

            :deep(.icon-chevron-down) {
                position: absolute;
                top: 54%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
        }

        .dropdown-content {
            transition: opacity var(--joy-transition-duration-normal) var(--joy-transition-timing-function);
            position: absolute;
            top: calc(100% + 40px);
            background-color: var(--joy-color-background-default);
            box-shadow: var(--joy-core-elevation-3);
            opacity: 0;
            display: none;
            z-index: var(--joy-core-z-index-dropdown);

            &.open {
                display: block;
                opacity: 1;
                transition: opacity var(--joy-transition-duration-normal) var(--joy-transition-timing-function) display 0
                    var(--joy-transition-duration-normal) var(--joy-transition-timing-function);
            }
        }
    }
</style>
